export default {
    integer: new RegExp('^[0-9-]+$'),
    float:   new RegExp('^[0-9.-]+$')
};
